import { Navigate, useNavigate } from "react-router-dom"

import { useAppDispatch, useAppSelector } from "store/hooks"
import { setInitialURL } from "store/tempDataSlise"

import { UserRole } from "utils/checkRoleType"
import { isRestrictedSubscriptionPlan } from "utils/isRestrictedSubscriptionPlan"

export const RedirectPage = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const initialURL = useAppSelector(state => state.tempData.initialURL)
  const userProfile = useAppSelector(state => state.user.userProfile)

  if (!userProfile) {
    return <Navigate to="/auth/sign-in" replace />
  }

  if (initialURL) {
    navigate(initialURL)
    dispatch(setInitialURL(undefined))
    return null
  }

  if (isRestrictedSubscriptionPlan(userProfile)) {
    return <Navigate to="/" replace />
  }

  if ([UserRole.VendorAdmin, UserRole.SalesManager].includes(userProfile.type)) {
    return <Navigate to="/contractors" replace />
  }

  if (userProfile.type === UserRole.WarehouseManager) {
    return <Navigate to="/wh-orders" replace />
  }

  if (userProfile.type === UserRole.ContractorTechnician) {
    return <Navigate to="/customers" replace />
  }

  return <Navigate to="/dashboard" replace />
}
